<template>
  <div>
    <div class="flex flex-row gap-2 mb-2">
      <img 
        v-if="result && !loading"
        class="w-52 h-52 rounded-md"
        :class="{'border-2 border-bc-blue': isSelected}"
        :src="result.previewUrl"
        @contextmenu.prevent.stop
      >
      <div
        v-else-if="!result && loading"
        class="w-52 h-52"
      >
        <aw-icon 
          icon="loader" 
          class="h-full w-full"
        />
      </div>
      <div
        v-else
        class="w-52 h-52 inline-flex items-center justify-center border border-gray-300 rounded-md"
      >
        <aw-icon 
          icon="image" 
          class="h-1/2 w-1/2 text-gray-400"
        />
      </div>
      <textarea 
        :placeholder="$t('Write detailed description of the image')"
        class="form-control !inline-flex !w-auto flex-grow"
        v-model="keywords"
      />
    </div>
    <div class="flex justify-end">
      <button 
        type="button" 
        class="btn btn-primary-outlined h-12 btn-xs select-none"
        :class="{'btn-disabled pointer-events-none': loading || !keywords}"
        @click.stop.prevent="loadImage()"
      >
        {{ $t('Generate new') }}
      </button>
      <button 
        v-if="!isSelected"
        type="button" 
        class="btn btn-primary h-12 ml-3"
        :class="{'btn-disabled pointer-events-none': !result || loading }"
        @click.stop.prevent="chooseImage()"
      >
        {{ $t('Use image') }}
      </button>
      <span 
        v-else-if="isSelected"
        class="btn btn-primary h-12 ml-3 pointer-events-none"
      >
        {{ $t('Image is used') }}
        <aw-icon 
          icon="done-all" 
          class="h-6 w-6 text-white"
        />
      </span>
    </div>
  </div>
</template>

<script>
import axios from 'axios'
import { PhotobankApi } from '../../test-api/index.ts'
import handleApiError from '../../utils/handleApiError'

const photobankApi = new PhotobankApi({}, '/api/v2')
let cancelationToken
const CancelToken = axios.CancelToken;

export default {
  mixins: [
  ],
  data () {
    return {
      keywords: null,
      limit: 1,
      offset: 0,
      loading: false,
      result: null,
    }
  },
  computed: {
    isSelected() {
      return this.$formValues['frm-editForm-editForm-preview__url'] === this.result?.fullsizeUrl
    }
  },
  methods: {
    chooseImage() {
      this.$formValues['frm-editForm-editForm-preview__url'] = this.result.fullsizeUrl
      this.$formValues['frm-editForm-editForm-preview__meta_data'] = JSON.stringify(this.result.metadata)
    },
    async loadImage () {
      this.loading = true
      this.result = null

      if (cancelationToken !== undefined) {
        cancelationToken.cancel();
        cancelationToken = undefined
      }

      cancelationToken = CancelToken.source()
      const photobankImagesResponse = await handleApiError(() => photobankApi.photobankImages('gpt', this.keywords, this.limit, this.offset, {
        cancelToken: cancelationToken.token
      }))

      this.result = photobankImagesResponse.data.results[0]
      this.loading = false
    },
  },
}
</script>

<style lang="scss" scoped></style>
